module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm01"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagevii"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle2"
  })])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "pagevii"
    }
  }, [_c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("I am indebted to the following for support and advice:")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("Carolyn Doty, Louise Quayle, and Robert Jones; Jill Bauerle, Darren Brown, Michael Burkin, Eryk Casemiro, Dennis Cooper, Pamela Erwin, Donna Goertz, Marion Heim, Tamyra Heim, Anthony Knight, Eamonn Maguire, Denise Marcil, Kirk McDonald, Perry McMahon, Anne-Marie O’Farrell, Mike Peterson, Jamie Reisch, Scott Savaiano, and Helen Schulman.")])]), _c('a', {
    attrs: {
      "id": "pageviii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pageviii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pageviii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-586fbcd5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780061737190_frontmatterpage.vue
// module id = 69
// module chunks = 0